// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__36hka","productName":"Table_productName__3tFV4"};